import axios from 'axios';

export const PatientApis = {
  updateProfile: async (payload) => {
    try {
      const response = await axios.patch(
        `${process.env.REACT_APP_SERVER_URL}/api/v1/auth/update-profile`,
        payload,

        {
          withCredentials: true,
        }
      );
      console.log('response from patch api', response);
    } catch (error) {
      console.error('Error updating the conversation', error);
      throw error;
    }
  },

  updatePhoto: async (data) => {
    try {
      return await axios.post(
        `${process.env.REACT_APP_SERVER_URL}/api/v1/auth/profilePhoto-update`,
        data,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
          withCredentials: true,
        }
      );
    } catch (error) {
      console.error('Error updating the conversation', error);
      throw error;
    }
  },

  deleteManyArchive: async (payload) => {
    console.log('payload for deleting mutiple', payload);
    try {
      const response = await axios.delete(
        `${process.env.REACT_APP_PATIENT_SERVER_URL}/api/v1/patient/conversation/archived`,
        {
          data: {
            conversation_ids: payload, // Wrap in object!
          },
          withCredentials: true,
        }
      );
      return response;
    } catch (error) {
      console.error('Error deleting archived conversation', error);
      throw error;
    }
  },

  restoreManyArchive: async (payload) => {
    console.log('payload valeu in retor emany archive', payload);
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_PATIENT_SERVER_URL}/api/v1/patient/conversation/unarchive-many`,
        {
          conversation_ids: payload, // ✅ fix here
        },
        {
          withCredentials: true,
        }
      );
      console.log('response from the restore many conversations', response);
      return response;
    } catch (error) {
      console.error('Error while restoring archive conversations', error);
      throw error;
    }
  },

  archiveConversation: async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_PATIENT_SERVER_URL}/api/v1/patient/conversation/archived`,
        {
          withCredentials: true,
        }
      );
      return response;
    } catch (error) {
      console.error('Error fetching the archieve conversation', error);
      throw error;
    }
  },
  ArchieveRestore: async (conv_id) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_PATIENT_SERVER_URL}/api/v1/patient/conversation/unarchive/${conv_id}`,
        {}, // send no body
        {
          withCredentials: true, // ✅ This ensures cookie gets sent
        }
      );
      console.log('archieve api call', response);
      return response;
    } catch (error) {
      console.error('Error while restoring the archived conversation', error);
      throw error;
    }
  },
  ArchieveDelete: async (conv_id) => {
    try {
      const response = await axios.delete(
        `${process.env.REACT_APP_PATIENT_SERVER_URL}/api/v1/patient/delete-archive/${conv_id}`,
        {
          withCredentials: true,
        }
      );
      return response;
    } catch (error) {
      console.error('error while deleting the archieved conversation', error);
      throw error;
    }
  },

  submitFeedback: async (rating, submitFeedback) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_PATIENT_SERVER_URL}/api/v1/patient/submit-feedback`,
        {
          ratings: rating,
          feedback_text: submitFeedback,
        },
        {
          withCredentials: true,
          headers: {
            'Content-Type': 'application/json',
          },
        }
      );
      return response;
    } catch (error) {
      console.error(
        'Error submitting feedback:',
        error.response?.data || error.message
      );
      throw error;
    }
  },
};
